import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=8e81f6a0&scoped=true&"
import script from "./visit.vue?vue&type=script&lang=js&"
export * from "./visit.vue?vue&type=script&lang=js&"
import style0 from "./visit.vue?vue&type=style&index=0&id=8e81f6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e81f6a0",
  null
  
)

export default component.exports